const breakPoint = 767;
let resizeFlag   = false;
let windowWidth  = window.innerWidth;
let windowHeight = window.innerHeight;
let windowWidthJ = $(window).width();
let musicid = 0;
let voiceid = 0;
let music;


const videoControl = (action, target) => {
  var $playerWindow = $(target)[0].contentWindow;
  $playerWindow.postMessage('{"event":"command","func":"' + action + '","args":""}', '*');
}


// ------------------------------------------------------------------------
// autoPlay
// ----- BOTH
// ------------------------------------------------------------------------
const autoPlay = () => {
  $(window).on("load", function () {
    if ($(".youtube-auto").length !== 0) {
      videoControl("playVideo", ".youtube-auto");
    }
  });
};


// ------------------------------------------------------------------------
// preload
// ----- BOTH
// ------------------------------------------------------------------------
const preload = () => {
  $(window).on("load", function () {
    $("body").removeClass("preload");
    $("body").css("opacity","");  
  });
};


// ------------------------------------------------------------------------
// anchorLink
// ----- BOTH
// ------------------------------------------------------------------------
const anchorLink = () => {
  $("a[href^='#']").on("click", function(){
    var linkSpeed    = 800;
    var linkHref     = $(this).attr("href");
    var linkTarget   = $(linkHref == "#" || linkHref == "" ? 'html' : linkHref);
    var linkAdjust   = 0;
    var linkPosition = linkTarget.offset().top;
    $("html, body").animate({scrollTop: linkPosition - linkAdjust}, linkSpeed, "swing");
    return false;
  });
};




// ------------------------------------------------------------------------
// toggleTotop
// ------------------------------------------------------------------------
const toggleTotop = (type) => {
  let visibleHeight = $('body').outerHeight();
  if ($(".idx-Pickup")[0]) {
    gsap.to('.st-Totop', {
      scrollTrigger: {
        trigger: ".idx-Pickup",
        start: 'top center',
        end: () => visibleHeight,
        toggleClass: { targets: ".st-Totop", className: "visible" },
      }
    });
  } else {
    gsap.to('.st-Totop', {
      scrollTrigger: {
        trigger: ".sw-Box",
        start: 'top center',
        end: () => visibleHeight * 1.5,
        toggleClass: { targets: ".st-Totop", className: "visible" },
      }
    });
  }
};



// ------------------------------------------------------------------------
// resizeHeader
// ------------------------------------------------------------------------
const resizeHeader = () => {
  let trgPos = 100;
  $(window).on("load scroll", function () {
    if (matchMedia('(min-width: 768px)').matches) {
      let scrollHeight = $(this).scrollTop();
      if (trgPos < scrollHeight) {
        $(".st-Header_Inner").addClass("resize");
      } else {
        $(".st-Header_Inner").removeClass("resize");
      }
    }
  });
};



// ------------------------------------------------------------------------
// toggleBanner
// ------------------------------------------------------------------------
const toggleBanner = () => {
  let trgPos = 0;
  $(window).on("load scroll", function () {
    let scrollHeight = $(this).scrollTop();
    if(trgPos < scrollHeight){
      $(".idx-Openrec").addClass("visible");
    } else {
      $(".idx-Openrec").removeClass("visible");
    }
  });
};



// ------------------------------------------------------------------------
// movieModal
// ------------------------------------------------------------------------
const toggleModal = () => {
  const ua = navigator.userAgent;
  $("[data-youtube]").on("click", function () {
    let youtubeId = $(this).data("youtube");
    let embedUrl = "https://www.youtube.com/embed/" + youtubeId + "?autoplay=1&enablejsapi=1";
    $('.modal-wrapper').append('<iframe id="modal-youtube" width="560" height="315" src="" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen=""></iframe>');
    $(".sw-Modal").addClass("open");
    if ($(".youtube-auto").length !== 0) {
      videoControl("pauseVideo", '.youtube-auto');
    }
    $('#modal-youtube').attr("src", embedUrl);
    $('#modal-youtube').on('load', function () {
      if (/android/i.test(ua) || matchMedia('(min-width: 768px)').matches) {
        videoControl("playVideo", '#modal-youtube');
        videoControl("unMute", '#modal-youtube');
      }
    });
    $('.modal-close , .sw-Modal').on('click', function () {
      $(".sw-Modal").removeClass("open");
      setTimeout(function () {
        $('.modal-wrapper iframe').remove();
        if ($(".youtube-auto").length !== 0) {
          videoControl("playVideo", '.youtube-auto');
        }
      }, 400);
    });
  });
};


// ------------------------------------------------------------------------
// toggleNav
// ------------------------------------------------------------------------
const toggleNav = () => {
  let flag = 0;
  let currentPos = 0;
  $(".st-Header_Button button").on("click", function () {
    $(".st-Header_Inner").toggleClass("open");
    $(".st-Header_Button button").toggleClass("open");
  });
};


// ------------------------------------------------------------------------
// animScroll
// ------------------------------------------------------------------------
const animScroll = () => {
  let margin = 0;
  if (matchMedia('(max-width: 768px)').matches) {
    margin = 150;
  } else {
    margin = 300;
  }
  $(".anm-sc").each(function (i, node) {
    gsap.to(node, {
      scrollTrigger: {
        trigger: node,
        start: 'top bottom-=' + margin,
        toggleClass: { targets: node, className: "animated" },
        once: true,
      }
    });
  });
};


// ------------------------------------------------------------------------
// animLoad
// ------------------------------------------------------------------------
const animLoad = () => {
  $(window).on("load", function () {
    $(".anm-ld").toggleClass("animated");
  });
};



// ------------------------------------------------------------------------
// playVoice
// ------------------------------------------------------------------------
const playVoice = () => {
  $('.voice-toggle').on('click', function () {
    let voicefile = $(this).attr("data-voice");
    let voice = new Howl({
      src: voicefile,
      preload: true,
      html5: true,
      onend: function () {

      }
    });
    if(voiceid > 0){
      Howler.stop();
      voiceid = 0;
      voiceid = voice.play(voiceid);
    } else {
      voiceid = voice.play(voiceid);
    }
  });
};


// ------------------------------------------------------------------------
// storySlider
// ----- BOTH
// ------------------------------------------------------------------------
const storySlider = () => {
  let gl = new Swiper('.story-slider', {
    speed: 600,
    slidesPerView: "auto",
    centeredSlides: true,
    preventClicks: true,
    simulateTouch: true,
    initialSlide: 0,
    loop: true,
    effect: "fade",
    fadeEffect: {
      crossFade: true
    },
    pagination: {
      el: '.story-dot',
      type: 'bullets',
      clickable: true,
    },
    navigation: {
      nextEl: ".story-nav_next",
      prevEl: ".story-nav_prev",
    },
  });
};


export {
  preload,
  autoPlay,
  anchorLink,
  resizeHeader,
  toggleBanner,
  toggleModal,
  toggleNav,
  animScroll,
  animLoad,
  playVoice,
  storySlider
}



// WEBPACK FOOTER //
// ./src/assets/js/include/module.js